/**
 * handleEditSubmit.js
 *
 * Copyright (c) apploft. GmbH
 */

import {http, URL, APIDefinition} from 'apploft-cloud-client';
import {createRequestData} from 'apploft-cloud-forms';
import {submittingForm} from '../ContentStateSymbol';
import {
  formResponseReceived,
  failedFormSubmission,
} from '../ContentEventSymbol';

export default function handleEditSubmit(
  {section, api},
  {item: {objectId}, formData, dispatch},
) {
  const paths = APIDefinition.pathsMatching(section, api);
  const url = URL.createPutUrl({api, paths, objectId});
  const authorization = APIDefinition.keyAdminAuth(api);
  const controller = new AbortController();

  const {signal} = controller;
  const {put} = http;

  const data = createRequestData(formData);

  put({url, data, authorization, signal})
    .then(res => {
      // Assuming we are reloading the list in the success case, we can ignore
      // the response here.

      dispatch({
        event: formResponseReceived,
        payload: {section, api, dispatch},
      });
    })
    .catch(error => {
      if (error instanceof DOMException) {
        console.assert(
          error.message === 'The user aborted a request.',
          `unexpected error: ${error.message}`,
        );

        return;
      }

      dispatch({event: failedFormSubmission, payload: error});
    });

  return {
    state: submittingForm,
    data: {section, api, formData},
    controller,
  };
}
